// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1UFo9","errorLogs":"styles_errorLogs__8k4Yn"};